<template>
  <div class="hstack justify-content-center btn-group shadow">
    <!-- Not using "disabled" prop so tooltip still shows with an explanatory message -->
    <button
        type="button"
        v-for="t in types"
        :key="`new-item-${t}`"
        class="btn btn-dark"
        :class="{ 'not-allowed': t.item_type === 'image' && disableImage }"
        v-tooltip="getTooltipContent(t)"
        @click="t.item_type === 'image' && disableImage ? () => {} : $emit('input', t.item_type)"
    >
      <i :class="`fas fa-${t.icon}`" />
      <span class="visually-hidden">{{t.label}}</span>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType, ItemType } from "@/types";

export default defineComponent({
  name: "NewItemOptions",
  emits: ["input"],
  props: {
    types: {
      type: Array as PropType<ItemType[]>,
      required: true,
    },
    disableImage: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getTooltipContent(item: ItemType) {
      return item.item_type === 'image' && this.disableImage
        ? this.$t("backend.candidacy.forms.image.image_taken")
        : item.label;
    },
  },
});
</script>

<style scoped>
.not-allowed {
  color: rgba(var(--bs-light-rgb), 0.6);
}

.not-allowed:hover {
  cursor: not-allowed;
  background-color: var(--bs-dark);
  border-color: var(--bs-dark);
}

.not-allowed:active {
  color: rgba(var(--bs-light-rgb), 0.6);
}
</style>